<template>
  <BaseNew @new-confirm-action="emitNfe" @new-cancel-action="resetForm" @new-open-action="mainLoadServerEntry"
    @clear-form-errors="clearFormErrors" ref="baseNew" :modelNameSingular="modelNameSingular"
    newCreateButtonLabel="Emitir NFS-e" width="80%" :formErrors="formErrors" :loading="loading"
    :pageLoading="pageLoading" :inlineAddButton="inlineAddButton" addButtonIcon="mdi-account-wrench-outline"
    newSaveButtonLabel="Emitir NFS-e" :useModelInsteadOfButton="useModelInsteadOfButton">
    <template slot="newForm">
      <Form ref="form" :entry="entry" :extraData="extraData" @formLoading="pageLoading = true"
        @formStopLoading="pageLoading = false" @formErrors="errorsFromForm" :printing="printing" id="printableELement"
        formType="new" :modelNameSingular="modelNameSingular" />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";
import { type } from 'os';

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      printing: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "MDFe"
    },
    inlineAddButton: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    Form: Form,
    BaseNew: BaseNew,
  },
  methods: {
    mainLoadServerEntry: function () {
      // console.log("multiSale", this.multiSale);

      // if (this.multiSale){
      //   this.cashFlow = {id: this.multiSale.sales[0]};
      // }
      // console.log("cashFlow", this.cashFlow)
      // if (this.cashFlow) {
      this.loadServerEntry();
      // } else if (this.multiSale) {
      //   this.loadServerEntryMultiSale();
      // }
    },
    loadServerEntry: function () {
      this.error = null;
      this.loading = true;
      // console.log("nfe", this.nfe);
      // var id = this.nfe.id;
      // console.log("id", id)


      this.$apollo
        .query({
          query: LOAD_NEW_OUTBOUND_NFSE_QUERY,
          fetchPolicy: "no-cache",
          // variables: {

          // }
        })
        .then(response => {
          this.entry = response.data.accountContext.nfse;
          this.extraData = response.data;
          console.log("extra", this.extraData);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createServerEntry: function (nfse) {
      // console.log("NFP-e", nfpe, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(nfpe, this.entry.validations));
      this.pageLoading = true;
      // console.log("cse", nfpe);
      this.$apollo
        .mutate({
          mutation: CREATE_MDFE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(nfse, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.issueNfse.errors;
          // console.log(errors)
          if (errors.length) {
            this.formErrors = errors;
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.pageLoading = false;
            // this.$router.push({ name: "OutboundNfse"});
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    emitNfe: function () {
      if (this.$refs.form.isFormValid()) {
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function () {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function () {
      this.formErrors = [];
    },
    errorsFromForm: function (errors) {
      this.formErrors = this.formErrors.concat(errors);
    }
  }
};



const LOAD_NEW_OUTBOUND_NFSE_QUERY = gql`
   query{
    accountContext{
      nfse{
        id
        competence
      }
      allTaxPayers {
        id
        text
      }
      allCustomers{
        id
        name
      }
      allListServices{
        id
        name
      }
    }
  }
`;

const CREATE_NFSE_MUTATION = gql`
  mutation($input: IssueNfseInputObject!) {
    issueNfse(input: $input) {
      nfse {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
